

export const baseURL=

//"http://192.168.29.250:9998/api"

"https://api.rndsan.com/api"



//otp endpoint
export const otp_endpoint={
    SendOtp_API:baseURL+"/web/users/send-otp",
    VerifyOtp_API:baseURL+"/web/users/verify-otp",
}

//userCreate endpoint
export const user_endpoint={
    UserCreate_API:baseURL+"/web/users/user-create",
    patientassign:baseURL+'/web/users/create-patient'
}
export const medical_test={
    getAllService:baseURL+'/web/service/get-all-service',
    billCalculation:baseURL+'/web/service/calculate-bill',
    medicalTestOrder:baseURL+'/web/service/razorpay/order?amount='
}

//store endpoints
export const store_endpoint={
    OutlateFetch_API:baseURL+"/web/outlate/outlate-details",
}

//shop endpoints
export const shop_endpoint={
   fetchCategories_API:baseURL+"/web/product/getcategory",
   fetchProducts_API:baseURL+"/web/product/get-all-products-available-me-to-sell",
   fetchSubcategories_API:baseURL+"/web/product/subcategories/by-category",
   fetchProductsBySubcatagories_API:baseURL+"/web/product/products/by-subcategory",
}

export const enquiry_endpoint={
    Enquiry_API:baseURL+"/web/users/create-job-enquiry",
    Product_Enquiry_API:baseURL+"/web/users/create-product-enquiry",
    Create_partnership_API:baseURL+"/web/users/create-partnership",

}


//review question endpoint
export const review={
    reviewQuestionGet:baseURL+"/web/rivew/review-questions",
    reviewAnswer:baseURL+"/web/rivew/submit",
}

export const profile={
    getProfile_API:baseURL+"/web/users/getprofile",
    getWishlist_API:baseURL+"/web/wishlist/user/wishlist",
    orderHistory_API:baseURL+'/web/cart/checkout-history',
    editProfile:baseURL+"/web/users/edit-profile",
    getCustomized_API:baseURL+'/web/cart/my-requests',
    customizeTestReport:baseURL+'/web/cart/testing-report/customized-request/',
    serviceHistory:baseURL+'/web/service-products/get-history',
    cartInvoice:baseURL+'/web/cart/invoice/',
    sendSupportMessage:baseURL+'/web/customer-support/send-message',
    getSupportMessages:baseURL+'/web/customer-support/support/chat/',
    mySupportsMessages:baseURL+'/web/customer-support/my-supports',
    replySupportMessage:baseURL+'/web/customer-support/support/reply',
}

export const cart={
    addToCart_API:baseURL+"/web/cart/add",
    increament_API:baseURL+"/web/cart/increase",
    decreament_API:baseURL+"/web/cart/decrease",
    viewCart_API:baseURL+"/web/cart/current",
    removeItem_API:baseURL+"/web/cart/remove",
    clearCart_API:baseURL+"/web/cart/clear",
    checkout_API:baseURL+'/web/cart/create-checkout',
    rozarpay_order_API:baseURL+'/web/razorpay/order',
    razorpay_success_API:baseURL+'/web/razorpay/payment-success',
    service_add_API:baseURL+'/web/service-products/add',
    customizeBooking_api:baseURL+'/web/cart/customized-requests',
    addWishlist:baseURL+'/web/wishlist/add',
    sendSupportQuery:baseURL+'/web/customer-support/query-send',
    getSupportQuery:baseURL+'/web/customer-support/query/chat-history/1'
}
